import React from 'react'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {ReportsModuleIcon} from '@csrc/assets/icons'

export const inspectionsNavigation = [
	{
		id: 'ins.blank',
		title: 'inspections.nav.inspections',
		icon: <FontAwesomeIcon icon={ReportsModuleIcon}/>,
		navLink: '/inspections',
		action: 'call',
		resource: 'INS_VIEW_INSPECTION_LIST'
	}
]
